import { NgModule } from '@angular/core';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import { CollaboratorChipsComponent } from './collaborator-chips.component';
import { CollaboratorService } from 'app/services/collaborator.service';
 
import { TranslateModule } from '@ngx-translate/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    CollaboratorChipsComponent
  ],
  imports: [
    MatButtonModule,
    MatDialogModule,
    MatTableModule, 
    MatTabsModule,
    MatTooltipModule, 
    MatPaginatorModule, 
    MatSortModule, MatIconModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatChipsModule,
    MatAutocompleteModule,

    FormsModule,
    ReactiveFormsModule,

    TranslateModule,
    FuseSharedModule,
  ],
  exports: [
    CollaboratorChipsComponent
  ],
  providers: [
    CollaboratorService
  ]
})
export class CollaboratorChipsModule { }